'use client';

/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Container, Grid, Stack, Typography } from '@mui/material';
import cx from 'clsx';
import { useTranslations } from 'next-intl';

import { careerOffers } from '@/config/career-offers.config';
import colors from '@/styles/themes/colors';
import useScrollReveal from '@/utils/hooks/useScrollReveal';

import styles from './OffersSection.module.scss';

const OffersSection = () => {
  const t = useTranslations('career');
  const { setRef, isVisible } = useScrollReveal<HTMLDivElement>(careerOffers.length);

  return (
    <Container component="section" maxWidth="xl" className={styles.container}>
      <Grid container spacing={{ xs: 6, md: 12, xl: 20 }}>
        <Grid size={{ xs: 12, lg: 4 }}>
          <Stack className={styles.introColumn}>
            <Typography variant="h2" component="h2" color={colors.white}>
              {t('offers.title')}
            </Typography>
            <Typography variant="body1" color={colors.graytone300}>
              {t('offers.description')}
            </Typography>
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, lg: 8 }}>
          <Grid container spacing={{ xs: 10.5, md: 8 }}>
            {careerOffers.map((offer, index) => {
              const Icon = offer.icon;

              return (
                <Grid size={{ xs: 12, sm: 6 }} key={offer.id}>
                  <Box ref={setRef(index)} className={cx(styles.cardWrapper, { [styles.visible]: isVisible(index) })}>
                    <Stack className={styles.offerCard}>
                      <Stack
                        alignItems="center"
                        justifyContent="center"
                        className={cx(styles.iconWrapper, styles[offer.colorVariant])}
                      >
                        <Icon fill={offer.color} size={42} />
                      </Stack>
                      <Stack spacing={1}>
                        <Typography variant="subtitle1" component="h3" color={colors.white}>
                          {t(offer.titleKey as any)}
                        </Typography>
                        <Typography variant="body1" color={colors.graytone300}>
                          {t(offer.descriptionKey as any)}
                        </Typography>
                      </Stack>
                    </Stack>
                  </Box>
                </Grid>
              );
            })}
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default OffersSection;
